
    import Vue from 'vue';
    import { RouterLink } from 'vue-router'
    import documentTypeService from '@/apps/shared/services/documentType-service';
    import searchPersonService from '@/apps/shared/services/searchPerson-service';
    import phoneValidateService from '@/apps/shared/services/phone-service';
    import FilePathService from '@/apps/shared/services/filePath-service';
    import getSelectedProducerService from '@/apps/shared/services/selectedProducer-service';
    import AgeService from '@/apps/shared/utils/CheckAges';
    import WhatsApp from '@/apps/shared/components/WhatsApp.vue';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import localityService from '@/apps/shared/services/locality-service';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';


    export default Vue.extend({
        components: {
            RouterLink,
            WhatsApp,
            XBreadcrumb
        },
        busEvents: {
        },
        name: 'APPolicyOwner-view',
        data() {
            return {
                localityList:
                    function (params) {
                        return localityService.getLocalityList(params)
                    },
                piso: null,
                numDom: null,
                numDept: null,
                streetName: null,
                selectedLocality: null,
                hasLocality: null,
                localityId: null,
                zipCode: null,
                icon: null,
                originId: 4,
                capital: null,
                BreadcrumbText: "Datos de la persona que contrata",
                additionalCovers: [],
                coversDetail: [],
                vigencyStart: null,
                vigencyEnd: null,
                primerCuota: 0,
                DataPlan: {
                    planDescription: ''
                },
                expirationDate: null,
                activeStep: 0,
                localItems: [],
                autocompleteConfig: {
                    formatResult: NF.Autocomplete.Result.TAGS,
                    selection: NF.Autocomplete.Result.TAGS,
                    minimumInputLength: 4
                },
                currentStep: 1,
                smallSize: "small",
                totalStep: 3,
                leadId: null,
                documentTypeList: [{ id: "", text: "" }],
                numDoc: null,
                isNotSelectedDocumentType: true,
                docTypeSelected: null,
                maxSelections: 2,
                numDocChange: null,
                numDocExisting: null,
                disable: true,                
                nacimiento: null,   
                isPersonExist: false,
                nextButtonDisable: true,
                searchButtonDisable: true,
                policyOwner: null,
                formattedName: null,
                formattedBirthday: null,
                messageErrorDigits: null,
                areaCode: null,
                telephone: null,
                messageErrorPhone: null,
                email: null,
                isAssuredTitular: null,
                beneficiaries: null,
                multiplePeopleWithSameIdentifier: [],
                isPeopleWithSameIdentifierModalOpen: false,
                personWithSameIdentifierSelected: null,
                tabOneData: null,
                messageErrorAgeModal: null,
                messageErrorAgechecked: null,
                accept: true,
                messageErrorAge: null,
                personType: null,
                product: null,
                breadcrumbItems: [
                    { text: 'Inicio', path: '/ocasion-de-trabajo' },
                    { text: 'Agregar Persona a cubrir', path: '/ocasion-de-trabajo/contratante' }
                ],
                referente: null,
            }
        },
        created() {
            window.globalThis.validateNumDoc = (val) => {
                let valid = true;
                let message = "";

                if (!this.docTypeSelected) {
                    return { valid: false, message: "Debe seleccionar un tipo de documento." };
                }
              
                val = String(val || "").trim();  // Aseguramos que 'val' sea un string y lo limpiamos de espacios
                let numericVal = val.replace(/\D/g, "");

                if (this.docTypeSelected.id === 'D') {
                    if (numericVal.length !== 7 && numericVal.length !== 8) {
                        this.searchButtonDisable = true;
                        message = numericVal.length > 0 ? "La cantidad de dígitos es incorrecta." : "Este campo es obligatorio.";
                        valid = false;
                    } else {
                        if (this.numDocExisting !== numericVal) {
                            this.numDocChange = true;
                            this.numDocExisting = numericVal;
                        }
                        this.searchButtonDisable = false;
                        message = "";
                        valid = true;
                    }
                } else if (this.docTypeSelected.id === 'J') {
                    // Validar CUIT
                    if (numericVal.length !== 11 || !this.validarCuit(numericVal)) {
                        message = "CUIT inválido. Debe tener 11 digitos y comenzar con 30, 33 o 34";
                        valid = false;
                        this.searchButtonDisable = true;
                    } else {
                        this.searchButtonDisable = false;
                        message = "";
                        valid = true;
                    }
                }

                else {
                    this.searchButtonDisable = false;
                }

                if (!val) {
                    this.searchButtonDisable = true;
                }

                return { valid, message };
            };

        },
        methods: {
            setupAddressValidation(required: boolean) {
                const form = "#formData1";

                // Localidad
                NF.Validation.Field.removeField(form, "selectedLocality");
                if (required) {
                    NF.Validation.Field.addField(form, "selectedLocality", {
                        validators: {
                            notEmpty: {
                                message: "El campo Localidad es obligatorio."
                            }
                        }
                    });
                }

                // Calle
                NF.Validation.Field.removeField(form, "streetName");
                if (required) {
                    NF.Validation.Field.addField(form, "streetName", {
                        validators: {
                            notEmpty: {
                                message: "El campo Domicilio es obligatorio."
                            },
                            stringLength: {
                                max: 100,
                                message: "Máximo 100 caracteres."
                            }
                        }
                    });
                }

                // Número
                NF.Validation.Field.removeField(form, "numDom");
                if (required) {
                    NF.Validation.Field.addField(form, "numDom", {
                        validators: {
                            notEmpty: {
                                message: "El campo Número es obligatorio."
                            },
                            regexp: {
                                regexp: /^[0-9]{1,6}$/,
                                message: "Sólo números (1 a 6 dígitos)."
                            }
                        }
                    });
                }
            },

            forceValidateAddressIfNeeded() {
                if (!this.hasLocality) {
                    NF.Validation.Field.validate("#formData1", "selectedLocality");
                    NF.Validation.Field.validate("#formData1", "streetName");
                    NF.Validation.Field.validate("#formData1", "numDom");
                }
            },

            validarCuit(cuit) {
                // valida que tenga 11 dígitos numericos
                if (!/^\d{11}$/.test(cuit)) return false;

                // valida prefijo permitido: 30, 33, 34
                const prefix = cuit.substring(0, 2);
                if (!["30", "33", "34"].includes(prefix)) return false;

                // calculo de ultimo numero
                const mult = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
                let total = 0;

                for (let i = 0; i < 10; i++) {
                    total += parseInt(cuit[i]) * mult[i];
                }

                let resto = total % 11;
                let digito = resto === 0 ? 0 : resto === 1 ? 9 : 11 - resto;

                // Comparar con el ultimo numero ingresado
                return digito === parseInt(cuit[10]);
            },
            showRuletaErrorModal(show) {
                if (show) {
                    this.$refs.modalErrorRuleta.open();
                }
                else {
                    this.$refs.modalErrorRuleta.close();
                }
            },
            getFilePath() {
                FilePathService.getFilePath("UrlBase")
                    .then(response => {
                        var product = sessionStorage.getItem('productId');
                        var url;
                        switch (product) {
                            case "711":
                                url = 'integro-max'
                                break;
                            case "555":
                                url = 'ocasion-de-trabajo'
                                break;
                            case "387":
                                url = 'ap-24-hs'
                                break;
                            default:
                                break;
                        }
                        window.location.href = response + url;
                    });
            },
            onSelectedClient(id) {
                this.personWithSameIdentifierSelected = id;
                let selectedPerson = this.multiplePeopleWithSameIdentifier.find(item => this.personWithSameIdentifierSelected == item.id);

                if (this.docTypeSelected != "J") {

                    var checkAge = this.checkAge(selectedPerson.birthday, 18, 65);

                    if (checkAge.success || this.personType == 1) {
                        this.policyOwner = selectedPerson;
                        this.hasLocality = selectedPerson.hasLocality;
                        this.messageErrorAgeModal = null;
                        this.nextButtonDisable = false
                        this.formatName();
                        this.formatBirthday();
                        setTimeout(() => { this.closeSelectMultiplePeopleModal(); }, 300);
                    }
                    else {
                        this.messageErrorAgeModal = checkAge.message;
                        this.nextButtonDisable = true;
                    }
                }
            },

            checkAge(fechaNacimiento, edadMinima, edadMaxima) {
                let response = AgeService.checkAge(fechaNacimiento, edadMinima, edadMaxima)

                return response;
            },

            openSelectMultiplePeopleModal(peopleList) {
                this.isPeopleWithSameIdentifierModalOpen = true;
                this.resetMultiplePeopleModalValues();
                let idCounter = 1;
                this.multiplePeopleWithSameIdentifier = peopleList.map(person => {
                    let newPerson = {
                        id: idCounter++,
                        birthday: person.birthday,
                        firstName: person.firstName? person.firstName: "",
                        lastName: person.lastName,
                        email: person.email,
                        ivaConditionFiscalId: person.ivaConditionFiscalId,
                        areaCode: person.phoneAreaCode,
                        telephone: person.phoneNumber,
                        hasLocality: person.hasLocality,
                        address: null,
                        document: null,
                        localityName: person.localityName
                    };
                    if (person.address != null && person.address != undefined) {
                        newPerson.address = {
                            cityId: person.address.cityId,
                            streetNumber: person.address.streetNumber,
                            streetName: person.address.streetName,
                            zipCode: person.address.zipCode,
                            floor: person.address.floor,
                            department: person.address.department
                        };
                    };
                    if (person.document != null && person.document != undefined) {
                        newPerson.document = person.document;
                    };
                    return newPerson;
                });
                this.$refs.selectMultiplePeopleModal.open();
            },
            resetMultiplePeopleModalValues() {
                this.multiplePeopleWithSameIdentifier = [];
                this.personWithSameIdentifierSelected = null;
            },
            closeSelectMultiplePeopleModal: function () {
                this.isPeopleWithSameIdentifierModalOpen = false;
                this.resetMultiplePeopleModalValues();
                this.$refs.selectMultiplePeopleModal.close();
            },            
            async pageCustomization() {
                var product = sessionStorage.getItem('productId');
                let defaultTitle = '';
                let actualPath = '';
                let icon = '';
                switch (product) {
                    case '711': defaultTitle = 'Integro Max'; this.productName = "apintegro"; actualPath = '/integro-max'; icon = "/Logos/AP_Integro.svg"; this.product = "apintegro"; break;
                    case '555': defaultTitle = 'Ocasión de Trabajo'; this.productName = "aptrabajo"; actualPath = '/ocasion-de-trabajo'; icon = "/Logos/AP_OT.svg"; this.product = "aptrabajo"; break;
                    case '387': defaultTitle = 'AP - 24HS'; this.productName = "ap24"; actualPath = '/ap-24-hs'; icon = "/Logos/AP_24.svg"; this.product = "ap24"; break;
                }
                const actualStep = 'optionals';
                this.icono = icon
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, null);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },
            openCancelModal() {
                this.$refs.cancelModal.open();
            },
            closeCancelModal() {
                this.$refs.cancelModal.close();
            },
            anterior() {
                sessionStorage.removeItem("pressBack");
                sessionStorage.setItem("pressBack", "true");
                var product = sessionStorage.getItem('productId');
                var route;
                switch (product) {
                    case "711":
                        route = 'integro-max-tab-four'
                        break;
                    case "555":
                        route = 'ocassion-of-work-tab-four'
                        break;
                    case "387":
                        route = 'ap-24-hs-tab-four'
                        break;
                    default:
                        break;
                }
                this.$router.push({
                    name: route,
                })
            },
            setOwnerInSession() {

                var firstName = this.policyOwner.firstName
                var lastName = this.policyOwner.lastName

                searchPersonService.SetCustomPerson("PolicyOwner", lastName, firstName);
            },
            startProducerDataTask() {
                return new Promise((resolve, reject) => {
                    let data = JSON.parse(sessionStorage.getItem("TabTwoData"));
                    let data1 = JSON.parse(sessionStorage.getItem("TabOneWelcome")!);
                    if (data != null) {
                        getSelectedProducerService.GetSelectedProducer(
                            0,
                            data1.selectedLocality.id,
                            0,
                            this.originId,
                            data1.selectedLocality.zipCode
                        ).then(producerData => {
                            sessionStorage.removeItem("producerData");
                            sessionStorage.setItem("producerData", JSON.stringify(producerData));
                            this.producerDataLoaded = true;
                            resolve(true);
                        }).catch(error => {
                            this.showRuletaErrorModal(true);
                            window.globalThis.dataLayer.push({ 'pas': null, 'email': this.email, 'product': this.product, 'event': 'errorServidor', 'paso': 'cotizador-' + this.product + '-datos-contratante', 'referente': this.referente });
                            reject(error);
                        });
                    }
                });
            },
            siguiente() {
                NF.UI.Page.blockCustom({ message: 'Aguarde un instante...' });

                if (!this.hasLocality) {
                    const faltaLocalidad = !this.selectedLocality || !this.selectedLocality.id;
                    const faltaCalle = !this.streetName || this.streetName.trim() === "";
                    const faltaNumero = !this.numDom || String(this.numDom).trim() === "";

                    if (faltaLocalidad || faltaCalle || faltaNumero) {
                        NF.UI.Page.unblock();
                        return;
                    }
                    else {
                        this.policyOwner.localityName = this.selectedLocality.name;
                        this.policyOwner.localityId = this.selectedLocality.id;
                        this.policyOwner.zipCode = this.selectedLocality.zipCode;
                        this.policyOwner.provinceName = this.selectedLocality.provinceName;
                        this.policyOwner.text = this.selectedLocality.text;
                        this.policyOwner.streetName = this.streetName;
                        this.policyOwner.numDom = this.numDom;
                        this.policyOwner.addresFromFront = true;                        
                    }
                }
                else {
                    this.policyOwner.addresFromFront = false;
                }

                this.policyOwner.beneficiaries = this.beneficiaries;
                this.policyOwner.email = this.email;
                this.policyOwner.areaCode = this.areaCode;
                this.policyOwner.telephone = this.telephone;
                

                sessionStorage.removeItem("contratante");
                sessionStorage.setItem("contratante", JSON.stringify(this.policyOwner));

                sessionStorage.removeItem("ownerIsInsured");

                if (this.personType == 1) {
                    sessionStorage.setItem("ownerIsInsured", "false");
                }
                else {
                    sessionStorage.setItem("ownerIsInsured", JSON.stringify(!this.isAssuredTitular));
                }

                sessionStorage.removeItem("pressBack");
                sessionStorage.setItem("pressBack", "false");

                this.startProducerDataTask().then((result) => {
                    this.setOwnerInSession();
                    var product = sessionStorage.getItem('productId');
                    var route;
                    if (result == null) {
                        NF.UI.Page.unblock();
                        this.showRuletaErrorModal(true);
                        window.globalThis.dataLayer.push({
                            'pas': null,
                            'email': this.email,
                            'product': this.product,
                            'event': 'errorServidor',
                            'paso': 'cotizador-' + this.product + '-datos-contratante',
                            'referente': this.referente
                        });
                    }
                    else {
                        switch (product) {
                            case "711":
                                route = 'integro-max/datosAsegurado'
                                break;
                            case "555":
                                route = 'ocasion-de-trabajo/datosAsegurado'
                                break;
                            case "387":
                                route = 'ap-24-hs/datosAsegurado'
                                break;
                            default:
                                break;
                        }
                        window.location.href = '../' + route;
                    }
                })
                    .catch((error) => {
                        NF.UI.Page.unblock();
                        this.showRuletaErrorModal(true)
                    });
            },           
            formatDate(dateString) {
                dateString = dateString.replace(/^"|"$/g, '');
                const [year, month, day] = dateString.split('T')[0].split('-');
                return `${day}/${month}/${year}`;
            },
            getDocumentType() {
                if (this.personType == 0) {
                    documentTypeService.getDocumentTypeList().then(response => {
                        if (response.length != 0) {
                            this.documentTypeList = response.map(element =>
                                ({ ...element, id: element["id"], text: element["name"] }))
                            this.docTypeSelected = this.documentTypeList.find(p => p.name.trim() == "DNI");
                        }
                    })
                }
                else {
                    const cuitOption = { id: "J", name: "CUIT", text: "CUIT" };
                    this.documentTypeList = [cuitOption];
                    this.docTypeSelected = cuitOption;
                }
            },
            isSelectedDocumentType() {
                this.isNotSelectedDocumentType = false;
                this.docTypeSelected != null ? this.docTypeSelected.name.trim() != "CUIT" ? (this.isPerson = true, this.isJuridico = false) : (this.isJuridico = true, this.isPerson = false) : null
                this.numDoc = "";
                this.birthday = null;
                this.piso = "";
                this.numDept = "";
                this.numDom = "";
                this.streetName = null;
                this.searchButtonDisable = true;
                this.hasLocality = false;
            },
            searchPersonData() {
                this.streetName = null;
                this.piso = null;
                this.numDom = null;
                this.numDept = null;
                this.selectedLocality = null;
                this.getPersonByDocumentAndType();
                window.globalThis.dataLayer.push({
                    'pas': null,
                    'email': this.email,
                    'product': this.product,
                    'event': 'cotizador-' + this.product + '-datos-contratante',
                    'referente': this.referente
                });
            },
            getPersonByDocumentAndType() {
                NF.UI.Page.blockCustom({ message: 'Espere mientras buscamos...' });

                const Dni = this.numDoc;
                //const DocTypeSeleccionado = this.docTypeSelected.name.trim();

                searchPersonService.GetSearchPersonData(Dni, this.docTypeSelected.id)
                    .then(response => {
                        if (!response.searchPersonResult || response.searchPersonResult.length === 0) {
                            this.isPersonExist = false;
                            this.messageErrorAge = 'No encontramos registros con los datos ingresados. '
                                + 'Podés contactarnos al '
                                + '<a href="https://wa.me/5493493510404?from=numutiles" '
                                + 'target="_blank" rel="noopener noreferrer">'
                                + '+54 9 3493 510404</a> para ayudarte.';
                            NF.UI.Page.unblock();
                            return;
                        }

                        if (response.searchPersonResult.length > 1) {
                            this.openSelectMultiplePeopleModal(response.searchPersonResult);
                            this.isPersonExist = true;
                            NF.UI.Page.unblock();
                            return;
                        }

                        let checkAge;

                        if (this.docTypeSelected.id != "J") {
                            checkAge = this.checkAge(response.searchPersonResult[0].birthday, 18, 999);
                        }
                        else {
                            checkAge = { success: true, message: "" };
                        }

                        if (checkAge.success) {
                            this.messageErrorAge = null;
                            this.isPersonExist = true;
                            this.policyOwner = response.searchPersonResult[0];
                            this.hasLocality = response.searchPersonResult[0].hasLocality;
                            this.formatName();
                            this.formatBirthday();
                            this.isBirthdayCorrect = true;
                            this.nextButtonDisable = false;
                        } else {
                            this.isPersonExist = false;
                            this.messageErrorAge = checkAge.message;
                            this.nextButtonDisable = true;
                        }
                        NF.UI.Page.unblock();
                    })
                    .catch(error => {
                        this.messageErrorAge = "Error al obtener los datos de la persona.";
                        console.error(error);
                        window.globalThis.dataLayer.push({ 'pas': null, 'email': this.email, 'product': this.product, 'event': 'errorServidor', 'paso': 'cotizador-' + this.product + '-datos-contratante', 'referente': this.referente });
                        NF.UI.Page.unblock();
                    });
            },

            formatName() {
                    const formatName = (name) => {
                        return name
                            .toLowerCase()
                            .replace(/\b\w/g, (char) => char.toUpperCase()); // Poner en mayúscula la primera letra de cada palabra
                };
                if (this.personType == 0) {
                    this.formattedName = `${formatName(this.policyOwner.firstName)} ${formatName(this.policyOwner.lastName)}`;
                }
                else {
                    this.formattedName = `${formatName(this.policyOwner.lastName)}`;
                }
            },
            formatBirthday() {
                const fechaObj = new Date(this.policyOwner.birthday);
                const fechaFormateada = fechaObj.toLocaleDateString("es-AR");
                this.formattedBirthday = fechaFormateada;
            },

            getTelephoneValidation() {
                return new Promise<any>(async (resolve) => {
                    await this.validPhone();
                    NF.Validation.Field.removeField("#formData1", "areaCode");
                    NF.Validation.Field.removeField("#formData1", "telephone");

                    NF.Validation.Field.addField("#formData1", "areaCode", {
                        validators: {
                            stringLength: {
                                message: this.messageErrorAreaCode,
                            }
                        }
                    });
                    NF.Validation.Field.validate("#formData1", "areaCode");
                    NF.Validation.Field.addField("#formData1", "telephone", {
                        validators: {
                            stringLength: {
                                message: this.messageErrorPhone,
                            }
                        }
                    });
                    NF.Validation.Field.validate("#formData1", "telephone");
                })
            },
            validPhone: function () {
                if (this.telephone == "" && this.areaCode == "") {
                    this.validDigits = true;
                }
                return new Promise<any>(async (resolve) => {
                    await phoneValidateService.validatePhone(this.areaCode, this.telephone).then(async o => {
                        if (o.areaCodeSuccess == false) {
                            this.messageErrorAreaCode = o.message
                        }
                        if (o.phoneNumberSuccess == false) {
                            this.messageErrorPhone = o.message
                        }
                        if (o.validCountDigit != null) {
                            if (o.validCountDigit) {
                                this.messageErrorDigits = "";
                            }
                            else {
                                this.messageErrorDigits = o.message
                            }
                        }
                        else {
                            this.messageErrorDigits = "";
                        }
                        this.validatePhone = o.validCountDigit;
                        resolve(true);
                    });
                })
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'Default' + this.product + 'GTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },
        },
        watch: {
            areaCode(newVal) {
                if (newVal != null && newVal != "") {
                    this.getTelephoneValidation();
                }
            },
            telephone(newVal) {
                if (newVal != null && newVal != "") {
                    this.getTelephoneValidation();
                }
            },
            isAssuredTitular(newVal) {
                this.beneficiaries = "legalHeirs";
            },
            hasLocality(newVal) {
                // Si NO tiene dirección, esos campos pasan a ser obligatorios
                this.$nextTick(() => this.setupAddressValidation(!newVal));
            },
            isPersonExist(newVal) {
                if (newVal) {
                    // Al resolver la persona, ajustamos según 'hasLocality'
                    this.$nextTick(() => this.setupAddressValidation(!this.hasLocality));
                }
            },
            selectedLocality() {
                if (!this.hasLocality) {
                    NF.Validation.Field.validate("#formData1", "selectedLocality");
                }
            },
            streetName() {
                if (!this.hasLocality) {
                    NF.Validation.Field.validate("#formData1", "streetName");
                }
            },
            numDom() {
                if (!this.hasLocality) {
                    NF.Validation.Field.validate("#formData1", "numDom");
                }
            }
        },
        async mounted() {
            NF.UI.Page.block();
            this.vigencyStart = this.formatDate(sessionStorage.getItem("vigencyStart"));
            this.vigencyEnd = this.formatDate(sessionStorage.getItem("vigencyEnd"));

            this.beneficiaries = "legalHeirs";
            this.personType = JSON.parse(sessionStorage.getItem("TabTwoData")).personType

            var referente = sessionStorage.getItem("Referente");
            referente == 'null' || referente == null ? this.referente = null : this.referente = referente; 

            await this.pageCustomization();
            this.getDocumentType();            

            let planDataSelected = JSON.parse(sessionStorage.getItem("PlanSelected"));
            if (planDataSelected != null) {
                this.DataPlan = planDataSelected!;
                this.primerCuota = this.DataPlan.premioMensual;
                this.premiumWithoutDiscount = this.DataPlan.hasDiscount ? this.DataPlan.premiumWithoutDiscount : null;
                this.capital = this.DataPlan.capital;
                this.coversDetail = planDataSelected.calculosFinales;
                this.hasDiscount = this.DataPlan.hasDiscount;
            }
            let tabOneData = JSON.parse(sessionStorage.getItem("TabOneWelcome"));
            if (tabOneData != null) {
                this.areaCode = tabOneData.areaCode;
                this.telephone = tabOneData.telephone;
                this.email = tabOneData.email;
            }

            this.updateByProductGoogleAnalytics();
            
            window.globalThis.dataLayer.push({ 
                'pas': null, 
                'email': this.email,                 
                'product': this.product,                 
                'event': 'cotizador-'+this.product+'-dni',                 
                'value': parseInt(planDataSelected.premioSegunVigencia.replaceAll('.', ''), 10),
                'plan': planDataSelected.PlanName,
                'referente': this.referente});
                       
            this.setupAddressValidation(!this.hasLocality);
            sessionStorage.setItem("totalStep", this.totalStep.toString());
            sessionStorage.setItem("currentStep", "2");
            NF.UI.Page.unblock();
        }
    })
